/**
 * ProtectedRoute — gate that redirects unauthenticated users to /login.
 *
 * If the user has just signed up (`needsOnboarding` is true) and isn't
 * on the onboarding page yet, route them through it once. After that,
 * they land on the requested page on subsequent visits.
 */

import { Navigate, useLocation } from 'react-router-dom';

import { useAuthStore } from '@/stores/authStore';

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  const needsOnboarding = useAuthStore((s) => s.needsOnboarding);
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (needsOnboarding && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }
  return <>{children}</>;
}
